<template>
	<div class="site-backups-list-wrapper">
		<div>
			<ul class="nav nav-pills nav-pills-primary nav-pills-icons justify-content-center mb-2" role="tablist">
				<li class="nav-item">
					<a class="nav-link active" data-toggle="tab" href="#tab_visitors">
						Unique Visitors
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" data-toggle="tab" href="#tab_requests">
						Requests
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" data-toggle="tab" href="#tab_bandwidth">
						Bandwidth
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" data-toggle="tab" href="#tab_security">
						Security
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" data-toggle="tab" href="#tab_dns">
						DNS
					</a>
				</li>
			</ul>
			<div class="tab-content tab-space tab-subcategories mt-4"
				:style="{'display': showChart == false ? 'none' : 'block'}">
				<div class="tab-pane active" id="tab_visitors">
					<div class="card" :style="{'display': loading == true ? 'none' : 'block'}">
						<div class="loader"></div>
					</div>
					<Visitors
							:data="zoneStatistic"
							:countryList="countries"
							:periodZone="periodZone"
							:filter="filter"
							v-on:change-zone-period="changeZonePeriod"
							:style="{'display': loading == false ? 'none' : 'block'}"
					></Visitors>
				</div>
				<div class="tab-pane" id="tab_requests">
					<div class="card" :style="{'display': loading == true ? 'none' : 'block'}">
						<div class="loader"></div>
					</div>
					<Requests
							:data="zoneStatistic"
							:countryList="countries"
							:periodZone="periodZone"
							:filter="filter"
							v-on:change-zone-period="changeZonePeriod"
							:style="{'display': loading == false ? 'none' : 'block'}"
					></Requests>
				</div>
				<div class="tab-pane" id="tab_bandwidth">
					<div class="card" :style="{'display': loading == true ? 'none' : 'block'}">
						<div class="loader"></div>
					</div>
					<Bandwidth
							:data="zoneStatistic"
							:countryList="countries"
							:periodZone="periodZone"
							:filter="filter"
							v-on:change-zone-period="changeZonePeriod"
							:style="{'display': loading == false ? 'none' : 'block'}"
					></Bandwidth>
				</div>
				<div class="tab-pane" id="tab_security">
					<div class="card" :style="{'display': loading == true ? 'none' : 'block'}">
						<div class="loader"></div>
					</div>
					<Threats :data="zoneStatistic"
							:countryList="countries"
							:periodZone="periodZone"
							:filter="filter"
							v-on:change-zone-period="changeZonePeriod"
							:style="{'display': loading == false ? 'none' : 'block'}"
					></Threats>
				</div>
				<div class="tab-pane" id="tab_dns">
					<div class="card" :style="{'display': loading == true ? 'none' : 'block'}">
						<div class="loader"></div>
					</div>
					<DNS :account="account" :style="{'display': loading == false ? 'none' : 'block'}"></DNS>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import moment from "moment"
	import Requests from "./Requests"
	import Bandwidth from "./Bandwidth"
	import Visitors from "./Visitors"
	import Threats from "./Threats"
	import DNS from "./DNS"

	export default {
		name: "TrafficList",
		props: ['account'],
		components: {
			Requests,
			Bandwidth,
			Visitors,
			Threats,
			DNS
		},
		data: function () {
			return {
				showChart: true,
				loading: false,
				message: '',
				actionValue: '',
				actionType: false,
				dataCollection: null,
				zoneStatistic: {},
				countries: [],
				periodZone: '-43200',
				filter: {
					start_date: null,
					end_date: null
				}
			}
		},
		watch: {
			account() {
				this.loading = true;
				this.fetchZoneData();
			}
		},
		methods: {
			async fetchCountries() {
				try {
					const serverResp = await fetch('https://restcountries.eu/rest/v2/all')
					if (serverResp.ok) {
						const countryList = await serverResp.json()
						return countryList
					} else {
						throw new Error(`The network is returning ERROR: ${serverResp.status}`);
					}
				}
				catch (err) {
					throw new Error(err.message);
				}
			},
			changeZonePeriod(data) {
				this.filter = data.filter;
				if (data.type == 'period') {
					this.periodZone = data.period;
					this.filter = {
						start_date: null,
						end_date: null
					};
				}
				setTimeout(() => {
					this.fetchZoneData();
				}, 100);
			},
			fetchZoneData() {
				if (
					this.account.cloudflare.apiKey == 'NA' ||
					this.account.cloudflare.username == 'NA' ||
					!this.account.cloudflare.apiKey ||
					!this.account.cloudflare.username ||
					this.account.cloudflare.zone_id === undefined
				) {
					this.showChart = false;
					this.loading = true;
					return false;
				}
				this.showChart = true;
				this.loading = false;
				this.$http.post('analytics/zone', {
					'cloudflare_email': this.account.cloudflare.username,
					'cloudflare_api_key': this.account.cloudflare.apiKey,
					'cloudflare_zone': this.account.cloudflare.zone_id,
					'filter': {
						'since': this.filter.start_date ? moment(this.filter.start_date).utc().format() : this.periodZone,
						'until': this.filter.end_date ? moment(this.filter.end_date).utc().format() : 0,
					}
				}, {
					headers: {
						'Content-Type': 'application/json'
					}
				})
					.then((res) => {
						const data = res.data.data;
						const zoneStatistic = {
              totalUnique: 0,
              totalRequest: 0,
              totalCashedRequest: 0,
              totalUnCashedRequest: 0,
              totalBandwidth: 0,
              totalCashedBandwidth: 0,
              totalUnCashedBandwidth: 0,
              totalThreats: 0,
              date: [],
              bandwidth: [],
              cachedBandwidth: [],
              unCachedBandwidth: [],
              requests: [],
              cashedRequests: [],
              unCashedRequests: [],
              unique: [],
              threats: [],
              countryMap: []
            };
            console.log(data)
            const array = data.viewer.zones[0].httpRequests1dGroups || data.viewer.zones[0].httpRequests1hGroups
            for (let arr of array) {
              let date = arr.dimensions.date || arr.dimensions.datetime
              zoneStatistic.date.push(moment(date))
              zoneStatistic.bandwidth.push(arr.sum.bytes)
              zoneStatistic.cachedBandwidth.push({
                x: moment(date),
                y: arr.sum.cachedBytes
              })
              zoneStatistic.unCachedBandwidth.push({
                x: moment(date),
                y: arr.sum.bytes - arr.sum.cachedBytes
              })
              zoneStatistic.requests.push(arr.sum.requests)
              zoneStatistic.cashedRequests.push({
                x: moment(date),
                y: arr.sum.cachedRequests
              })
              zoneStatistic.unCashedRequests.push({
                x: moment(date),
                y: arr.sum.requests - arr.sum.cachedRequests
              })
              zoneStatistic.unique.push({
                x: moment(date),
                y: arr.uniq.uniques
              })
              zoneStatistic.threats.push({
                x: moment(date),
                y: arr.sum.threats
              })
              zoneStatistic.totalUnique += arr.uniq.uniques
              zoneStatistic.totalRequest += arr.sum.requests
              zoneStatistic.totalCashedRequest += arr.sum.cachedRequests
              zoneStatistic.totalUnCashedRequest += arr.sum.requests - arr.sum.cachedRequests

              zoneStatistic.totalBandwidth += arr.sum.bytes
              zoneStatistic.totalCashedBandwidth += arr.sum.cachedBytes
              zoneStatistic.totalUnCashedBandwidth += arr.sum.bytes - arr.sum.cachedBytes

              zoneStatistic.totalThreats += arr.sum.threats

              for (let cMap of arr.sum.countryMap) {
                const countryObject = zoneStatistic.countryMap.find((c)=> c.clientCountryName === cMap.clientCountryName)
                if (countryObject) {
                  countryObject.bytes += cMap.bytes
                  countryObject.requests += cMap.requests
                  countryObject.threats += cMap.threats
                } else {
                  zoneStatistic.countryMap.push(cMap)
                }
              }
            }
            console.log(zoneStatistic)
            this.zoneStatistic = zoneStatistic
          })
					.finally(() => {
						this.loading = true;
					})
			}
		},
		created() {
			this.fetchCountries()
				.then(countryList => {
					this.countries = [
						...countryList
					]
				})
		},
		mounted() {
			this.fetchZoneData();
		}
	};
</script>

<style>
	.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
		background-color: #FFFFFF;
	}

	input:read-only,
	textarea:read-only,
	[contenteditable]:read-only {
		cursor: pointer !important;
	}
</style>
